/* eslint-disable */
import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_ADDDRIVER, SET_ADDDRIVER, GET_DRIVERLIST,SET_DRIVERLIST,GET_EDITDRIVER,SET_EDITDRIVER,GET_DELETEDRIVER, SET_DELETEDRIVER, GET_ACTIVATEDRIVER, SET_ACTIVATEDRIVER, GET_EXPORTDRIVER, SET_EXPORTDRIVER, GET_DRIVERDETAIL, SET_DRIVERDETAIL, SET_LOCATEDDRIVERS, GET_LOCATEDDRIVERS, SET_IMPORTDRIVER, GET_IMPORTDRIVER, GET_STRIPELINKTODRIVER, SET_STRIPELINKTODRIVER,GET_VEHICLEBYTYPE,SET_VEHICLEBYTYPE } from '../actions';
import {apiUrl,sampleFileUrl } from "../components/Config/Config";
import Axios from 'axios';
//import cookie from 'react-cookies';

/*get driver detail*/

export const watchGetDriverDetail = function* () {
  yield takeEvery(GET_DRIVERDETAIL, workerGetDriverDetail);
}

function* workerGetDriverDetail({ driverid }) {
  var url = apiUrl+'driver/driverdetails?id='+driverid;
  try {
    const uri = url;
    const result = yield call(Axios.get, uri);
    var resultArr = [];
    resultArr.push(result.data)
    yield put({ type: SET_DRIVERDETAIL, value: resultArr });
  } 
  catch {
    console.log('Get Page Failed');
  }
}  

/*get driver list*/
export const watchGetDriverList = function* () {
  yield takeEvery(GET_DRIVERLIST, workerGetDriverList);
}

function* workerGetDriverList({ formVal }) {
  try {
      
 const result = yield call(getDriverList, formVal);
  var resultArr = [];
  resultArr.push(result.data);
    yield put({ type: SET_DRIVERLIST, value: resultArr });
  } 
  catch {
    console.log('post data failed');
  }
} 


function getDriverList(formPayload) {
   return Axios.post(apiUrl+'driver/list', formPayload);
} 

/*save the user*/

export const watchGetAddUser = function* () {
  yield takeEvery(GET_ADDUSER, workerGetAddUser);
}

function* workerGetAddUser({ formPayload }) {
  try {
      
 const result = yield call(getAddUser, formPayload);
  var resultArr = [];
  resultArr.push(result.data);
    yield put({ type: SET_ADDUSER, value: resultArr });
  } 
  catch {
    console.log('post data failed');
  }
} 


function getAddUser(formPayload) {
   return Axios.post(apiUrl+'user/add', formPayload);
} 


/*edit the user*/

export const watchGetEditDriver = function* () {
  yield takeEvery(GET_EDITDRIVER, workerGetEditDriver);
}

function* workerGetEditDriver({ formPayload }) {
  try {
      
 const result = yield call(getEditDriver, formPayload);
  var resultArr = [];
  resultArr.push(result.data);
    yield put({ type: SET_EDITDRIVER, value: resultArr });
  } 
  catch {
    console.log('post data failed');
  }
} 


function getEditDriver(formPayload) {
   return Axios.post(apiUrl+'driver/edit', formPayload);
} 


/*delete the user*/

export const watchGetDeleteDriver = function* () {
  yield takeEvery(GET_DELETEDRIVER, workerGetDeleteDriver);
}

function* workerGetDeleteDriver({ formPayload }) {
  try {
      
 const result = yield call(getDeleteDriver, formPayload);
  var resultArr = [];
  resultArr.push(result.data);
    yield put({ type: SET_DELETEDRIVER, value: resultArr });
  } 
  catch {
    console.log('post data failed');
  }
} 


function getDeleteDriver(formPayload) { console.log('test');
   return Axios.post(apiUrl+'driver/delete', formPayload);
} 


/*change status the user*/

export const watchActivateDriver = function* () {
  yield takeEvery(GET_ACTIVATEDRIVER, workerActivateDriver);
}

function* workerActivateDriver({ formPayload }) {
  try {
      
 const result = yield call(getActivateDriver, formPayload);
  var resultArr = [];
  resultArr.push(result.data);
    yield put({ type: SET_ACTIVATEDRIVER, value: resultArr });
  } 
  catch {
    console.log('post data failed');
  }
} 

function getActivateDriver(formPayload) {
   return Axios.post(apiUrl+'driver/change_status', formPayload);
} 


/*change status the user*/

export const watchStripLinkToDriver = function* () {
  yield takeEvery(GET_STRIPELINKTODRIVER, workerStripLinkToDriver);
}

function* workerStripLinkToDriver({ formPayload }) {
  try {
      
 const result = yield call(getStripLinkToDriver, formPayload);
  var resultArr = [];
  resultArr.push(result.data);
    yield put({ type: SET_STRIPELINKTODRIVER, value: resultArr });
  } 
  catch {
    console.log('post data failed');
  }
}


function getStripLinkToDriver(formPayload) {
   return Axios.post(apiUrl+'driver/generate_stripe_connective_link', formPayload);
} 


/*Export the user*/

export const watchExportDriver = function* () {
  yield takeEvery(GET_EXPORTDRIVER, workerExportDriver);
}

function* workerExportDriver({ formPayload }) {
  try {
      
 const result = yield call(getExportDriver, formPayload);
  var resultArr = [];
  resultArr.push(result.data);
    yield put({ type: SET_EXPORTDRIVER, value: resultArr });
  } 
  catch {
    console.log('post data failed');
  }
} 

function getExportDriver(formPayload) {
   return Axios.post(apiUrl+'driver/export', formPayload);
}


/*Locate Drivers*/
export const watchGetLocatedDrivers = function* () {
  yield takeEvery(GET_LOCATEDDRIVERS, workerGetLocatedDrivers);
}

function* workerGetLocatedDrivers({formPayload}) {
  try {
  const result = yield call(getLocatedtDriver, formPayload);
  var resultArr = [];
    yield put({ type: SET_LOCATEDDRIVERS, resultArr });
  } 
  catch {
    console.log('post data failed');
  }
}

function getLocatedtDriver(formPayload) {
   return Axios.post(apiUrl+'driver/locateddrivers', formPayload);
}


export const watchGetImportDriver = function* (){
	yield takeEvery(GET_IMPORTDRIVER, workerGetImportDriver);
}

function* workerGetImportDriver({ formPayload }) {
  try {
      
 const result = yield call(getImportDriver, formPayload);
  var resultArr = [];
  resultArr.push(result.data);
    yield put({ type: SET_IMPORTDRIVER, value: resultArr });
  } 
  catch {
    console.log('post data failed');
  }
}

function getImportDriver(formPayload) {
   return Axios.post(apiUrl+'driver/import', formPayload);
} 


/*get driver detail*/

export const watchGetVehicleByType = function* () {
  yield takeEvery(GET_VEHICLEBYTYPE, workerGetVehicleByType);
}

function* workerGetVehicleByType({ vehicleID }) {
  var url = apiUrl+'driver/getvehiclebytype?id='+vehicleID;
  try {
    const uri = url;
    const result = yield call(Axios.get, uri);
    var resultArr = [];
    resultArr.push(result.data)
    yield put({ type: SET_VEHICLEBYTYPE, value: resultArr });
  } 
  catch {
    console.log('Get Page Failed');
  }
}